"use client"

import { useRouter } from "next/navigation"

import { Button } from "@/components/ui/button"
import {
  PageHeader,
  PageHeaderDescription,
  PageHeaderHeading,
} from "@/components/page-header"
import { Shell } from "@/components/shells/shell"

export default function NotFoundPage() {
  const router = useRouter()

  return (
    <Shell variant="centered">
      <PageHeader>
        <PageHeaderHeading>Page not found</PageHeaderHeading>
        <PageHeaderDescription size="sm">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </PageHeaderDescription>
      </PageHeader>
      <div className="flex gap-4">
        <Button size="lg" onClick={() => router.push("/")}>
          Go home
        </Button>
        <Button size="lg" variant="outline" onClick={() => router.back()}>
          Go back
        </Button>
      </div>
    </Shell>
  )
}
